import * as React from "react";
import {observer} from "mobx-react";
import Table from "../../components/table/Table";
import useFeature from "../../useFeature";
import DeliverySitesPanelFeature from "./DeliverySitesPanelFeature";

function DeliverySitesPanel({application, navigator, businessName}) {
    const panelFeature = useFeature(
        () => new DeliverySitesPanelFeature(application, navigator, businessName),
        [businessName]
    );

    if (!panelFeature) return null;

    return (
        <Table
            columns={panelFeature.columns()}
            rows={panelFeature.presentedDeliverySites()}
            navigateToRowObjectScreen={(params) => panelFeature.navigateToDeliverySite(params.row)}
        />
    );
}

export default observer(DeliverySitesPanel);
